export default __webpack_public_path__ + "static/media/arrow-blue.7262109b.gif";